/**
 *  PreloaderScene
 *
 *  Created by Legman on 7/10/2015.
 *
 */

"use strict";

import Common from "./Common";

/**
 * @constructor
 * @extends {p3.Scene}
 */
function PreloaderScene() {

    /**
     * @type {number}
     */
    this.loaded = 0.0;

    /**
     * @type {PIXI.Sprite}
     */
    this._bar = null;

    /**
     * @type {PIXI.Sprite}
     */
    this._barBack = null;

    /**
     * @type {PIXI.Sprite}
     */
    this._bg = null;

    /**
     * @type {PIXI.BitmapText}
     */
    this._text = null;

    /**
     * @type {PIXI.BitmapText}
     */
    this._percent = null;

    /**
     * @type {string}
     */
    this._cheatyHax = "%";

    p3.Scene.call(this);
}

export default PreloaderScene;
PreloaderScene.prototype = Object.create(p3.Scene.prototype);
PreloaderScene.prototype.constructor = PreloaderScene;

PreloaderScene.prototype.init = function () {

    //console.log(Common.assets);

    this._bg = new PIXI.Sprite(Common.assets.getTexture("preloader_bg"));
    //this._barBack = new PIXI.Sprite(Common.assets.getTexture("preloader_bar"));


    //  this._text.y = p3.View.height * 0.5 - 75;
    //  this._text.x = Common.STAGE_WIDTH * 0.5 - 25;
    // this._percent.x = this._text.x + 65;

    // this._percent.y = this._text.y;

    // this._percent.visible = false;

    this.addChild(this._bg);

    var g = new PIXI.Graphics();
    g.beginFill(Common.language == 'es' ? 0xf1dc27 : 0x872F87);
    g.drawRect(0, 0, Common.STAGE_WIDTH, Common.STAGE_HEIGHT);
    g.endFill();
    this.addChild(g);

    var holder = new PIXI.Container();
    holder.x = Common.STAGE_WIDTH * 0.5;
    holder.y = Math.floor(p3.View.height * 0.5) + 50;
    this.addChild(holder);

    var logoFrames = [];
    for (var i = 1; i < 10; i++) {
        logoFrames.push(Common.assets.getTexture('loader_animation000' + i));
    }
    logoFrames.push(Common.assets.getTexture('loader_animation0010'));

    this._logoAnimation = new PIXI.extras.AnimatedSprite(logoFrames);
    this._logoAnimation.animationSpeed = 0.4;
    this._logoAnimation.gotoAndStop(0);
    this._logoAnimation.stop();
    this._logoAnimation.loop = false;
    this._logoAnimation.anchor.x = 0.5;
    this._logoAnimation.anchor.y = 1.0;
    this._logoAnimation.x += 50;
    this._logoAnimation.y -= 20;
    holder.addChild(this._logoAnimation);

    this._logoAnimation.play();

    this._bar = new PIXI.Sprite(Common.assets.getTexture('preloader_bar'));
    this._bar.anchor.y = 0.5;
    this._bar.x -= this._bar.width * 0.5;

    if(Common.language == 'es')
    {
        var bar = new PIXI.Graphics();
        bar.beginFill(0x00d3de);
        bar.x = this._bar.x;
        bar.y = this._bar.y;
        bar.drawRect(0, -this._bar.height/2, this._bar.width, this._bar.height);
        this._bar = bar;
    }

    this._bar.scale.x = 0;
    holder.addChild(this._bar);

    this._barOverlay = new PIXI.Sprite(Common.assets.getTexture(Common.language == 'es' ? 'preloader_overlay_es' : 'preloader_overlay'));
    this._barOverlay.anchor.y = 0.5;
    this._barOverlay.anchor.x = 0.5;
    holder.addChild(this._barOverlay);

    this._text = new PIXI.Text("0%", {fontFamily: 'Arial', fontSize: '38px', 'fill': Common.language == 'es' ? '#00d3de' : '#FFFFFF'});
    this._text.anchor.x = 0.5;
    this._text.position.y += 50;

    holder.addChild(this._text);

    if(Common.language == 'es')
    {
        this._logoAnimation.visible = false;
        var esLogo = new PIXI.Sprite(Common.assets.getTexture('preloader_es'));
        esLogo.anchor = new PIXI.Point(0.5, 1);
        esLogo.x = 0;
        esLogo.y = this._logoAnimation.y - 40;
        holder.addChild(esLogo);
    }
};

PreloaderScene.prototype.destroy = function () {
    p3.Scene.prototype.destroy.call(this);
};

PreloaderScene.prototype.appear = function () {
    this.animateIn();
};

PreloaderScene.prototype.show = function () {
};

PreloaderScene.prototype.animateIn = function (callback, scope) {

};

PreloaderScene.prototype.animateOut = function (callback, scope) {
};

PreloaderScene.prototype.resize = function () {
    this.x = (p3.View.width - Common.STAGE_WIDTH) * 0.5;
};

PreloaderScene.prototype.update = function () {

    var offset = 0;

    if(Common.language == 'es')
        offset = 5;

    this._bar.width = this._barOverlay.width * this.loaded - offset;
    if (this._bar.width > this._barOverlay.width - offset) this._bar.width = this._barOverlay.width - offset;
    this._text.text = "" + Math.round(this.loaded * 100) + "%";
    if (Math.round(this.loaded * 100) > 100) this._text.text = "100%";
};
